import { ReactElement } from "react";
import { Modal, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import firebase from "firebase/app";
import { SET_LOADING_STATE, RESET_LOADING_STATE } from "../../redux/constants";

type Props = {
  visible: boolean;
  onClose: () => void;
  onDone: (uid: string) => void;
  user: any;
};

export function RemoveConfirm({ visible, onClose, user, onDone }: Props): ReactElement {
  const dispatch = useDispatch()

  const onFinish = () => {
    dispatch({ type: SET_LOADING_STATE });
    firebase
      .firestore()
      .collection("users")
      .doc(user.id)
      .delete()
      .then(() => {
        message.success(`${user.fullName} has been removed.`);
        dispatch({ type: RESET_LOADING_STATE });
        onDone(user.id)
      })
      .catch((e) => {
        console.log(e);
        message.error("Oop! Something went wrong!");
        dispatch({ type: RESET_LOADING_STATE });
        onClose();
      });
  };

  return (
    <Modal
      title="Confirm"
      centered
      visible={visible}
      onOk={onFinish}
      onCancel={onClose}
    >
      <p>Are you sure to delete {user?.fullName}</p>
    </Modal>
  );
}
